export const addNumber = (number) => {

    return {
        type: 'ADD_NUMBER',
        number: number
    }
};